define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.StringUtil = exports.capitalise = exports.camelCaseToWords = exports.camelCase = exports.lowercase = exports.trim = exports.nullOrEmpty = exports.hasValue = void 0;
    function hasValue(x) {
        return x != undefined && x != null && x.length > 0 && x.trim().length > 0;
    }
    exports.hasValue = hasValue;
    function nullOrEmpty(x) {
        return !hasValue(x);
    }
    exports.nullOrEmpty = nullOrEmpty;
    function trim(x) {
        return x ? x.trim() : x;
    }
    exports.trim = trim;
    function lowercase(x) {
        return x ? x.toLowerCase() : x;
    }
    exports.lowercase = lowercase;
    function camelCase(str) {
        return str.replace(/[ ]{2,}/g, " ").toLowerCase().trim().split(" ").map(w => capitalise(w)).join(" ");
    }
    exports.camelCase = camelCase;
    function camelCaseToWords(x) {
        return (x ? x.replace(/([A-Z]+|\d+)/g, " $1").replace(/[ ]{2,}/g, " ") : "").trim();
    }
    exports.camelCaseToWords = camelCaseToWords;
    function capitalise(x) {
        return x && (x === null || x === void 0 ? void 0 : x.length) > 0 ? x.trim().charAt(0).toUpperCase() + x.trim().slice(1).toLowerCase() : "";
    }
    exports.capitalise = capitalise;
    class StringUtil {
        static isEmail(value) {
            return StringUtil.emailRegex.test(value);
        }
        static IsPhoneNumber(value) {
            if (value) {
                return StringUtil.phoneNumberRegex.test(value.replace(/ /g, ""));
            }
            return false;
        }
        static toTitleCase(value) {
            if (value) {
                let titleCaseStr = value.toLowerCase();
                const toUpperFxn = (...parameters) => {
                    return parameters[1].toUpperCase();
                };
                titleCaseStr = titleCaseStr.replace(/\b(\w)/g, toUpperFxn);
                return titleCaseStr;
            }
            return "";
        }
        static toNumberWith1kSep(x) {
            return x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
    exports.StringUtil = StringUtil;
    Object.defineProperty(StringUtil, "emailRegex", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i
    });
    Object.defineProperty(StringUtil, "phoneNumberRegex", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: /^\({0,1}((0|61|\+61)(\ |-){0,1}(2|4|3|7|8)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2,3}(\ |-){0,1}[0-9]{2,3}$/i
    });
});
